var _circle, _path, _path2, _path3, _path4, _path5;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgMyactivity(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 45,
    height: 45,
    viewBox: "0 0 45 45",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 22.5,
    cy: 22.5,
    r: 22.5,
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M26 12H20C19.4477 12 19 12.4477 19 13V15C19 15.5523 19.4477 16 20 16H26C26.5523 16 27 15.5523 27 15V13C27 12.4477 26.5523 12 26 12Z",
    stroke: "#444444",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M19 14H17C16.4696 14 15.9609 14.2107 15.5858 14.5858C15.2107 14.9609 15 15.4696 15 16V30C15 30.5304 15.2107 31.0391 15.5858 31.4142C15.9609 31.7893 16.4696 32 17 32H29C29.5304 32 30.0391 31.7893 30.4142 31.4142C30.7893 31.0391 31 30.5304 31 30V29.5",
    stroke: "#444444",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M27 14H29C29.3507 14.0004 29.6952 14.0929 29.9988 14.2685C30.3025 14.444 30.5546 14.6963 30.73 15",
    stroke: "#444444",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M29.42 19.61C29.615 19.415 29.8465 19.2603 30.1013 19.1548C30.3561 19.0492 30.6292 18.9949 30.905 18.9949C31.1808 18.9949 31.4539 19.0492 31.7087 19.1548C31.9635 19.2603 32.195 19.415 32.39 19.61C32.585 19.805 32.7397 20.0365 32.8452 20.2913C32.9508 20.5461 33.0051 20.8192 33.0051 21.095C33.0051 21.3708 32.9508 21.6439 32.8452 21.8987C32.7397 22.1535 32.585 22.385 32.39 22.58L27.95 27L24 28L24.99 24.05L29.42 19.61Z",
    stroke: "#444444",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M19 28H20",
    stroke: "#444444",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMyactivity);
export default __webpack_public_path__ + "static/media/my activity.57292312633e251377913127529c9d31.svg";
export { ForwardRef as ReactComponent };